import React from "react";
//#region types
import { LinearStateFlowContainerProps } from "models/propTypes/stateFlowPropTypes";
//#endregion
//#region components
import LinearStateFlow from "./linearStateFlow";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const LinearStateFlowContainer: React.FC<LinearStateFlowContainerProps> = (props) => {
  const { steps, translationKey } = props;

  const isActiveAtIntermediateState = steps.find((s) => s.active)?.isIntermediateState;
  const allMainSteps = steps.filter((s) => !s.isIntermediateState);
  let activeMainStep = 0;
  let activeState: any;

  if (isActiveAtIntermediateState) {
    const activeIndex = steps.findIndex((s) => s.active);
    for (let i = 0; i < activeIndex; i++) {
      if (!steps[i].isIntermediateState) {
        activeState = steps[i].status;
      }
    }
    activeMainStep = allMainSteps.findIndex((s) => s.status === activeState);
  } else {
    activeMainStep = allMainSteps.findIndex((s) => s.active);
  }

  const stateFlowSteps = allMainSteps.map((s) => {
    let stateText = " ";

    if (typeof translationKey === "function") {
      stateText = translationKey(s.status);
    } else {
      stateText = LocalizationHelperInstance.getFormattedMessage(`${translationKey}_${s.status}`);
    }

    return {
      state: s.status,
      stateText: stateText,
      updatedById: s.changedById,
      updatedByName: s.changedByName,
      date: s.date,
    };
  });

  return (
    <LinearStateFlow
      steps={stateFlowSteps}
      activeStep={activeMainStep}
      isActiveAtIntermediateState={isActiveAtIntermediateState}
    />
  );
};

export default LinearStateFlowContainer;
